<app-contact-info-form
	[(firstName)]="subscriptionItemService.customer.firstName"
	[(lastName)]="subscriptionItemService.customer.lastName"
	[(email)]="subscriptionItemService.customer.email"
	[(phone)]="subscriptionItemService.customer.phone"
	(addressChange)="onAddressEntry($event)"
	(formComplete)="submit()"
	buttonClass="p-button-success"
	buttonText="Next"
></app-contact-info-form>
